// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"6b8ee4f3","859":"aa348ff9"}[chunkId] + ".chunk.css";
};